// src/components/Home.js

import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const calculators = [
  {
    id: 'Faktura',
    title: 'FAKTURA',
    description: 'Izrada fakture sa svim potrebnim poljima i automatskim izračunima.',
  },
];

export default function Home() {
  return (
    <div className="home-wrapper">
      <h1 className="home-title">IZRADITE DOKUMENT</h1>
      <div className="cards-grid">
        {calculators.map((calc) => (
          <Link
            key={calc.id}
            to={`/${calc.id}`}
            className="card-link"
          >
            <div className="card">
              <h2 className="card-heading">{calc.title}</h2>
              <p className="card-desc">{calc.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
